import { IconAttributeTraveller } from '@components/icons/attribute-traveller';
import { IconPhone } from '@components/icons/phone';
import { PhoneField } from '@components/phone-field';
import { TextField } from '@components/text-field';
import { getScopedTranslate } from '@locale/translate';
import { asteriskLabel } from '@utils/strings';

import { FieldDropzone } from './field-dropzone';

import { conditionsTab } from '../conditions-tab';
import { useFormBuilderContext } from '../context';
import { FieldEdit } from '../field-edit';
import { FieldConfig } from '../field-registry';
import { FieldSidebarLabel } from '../fields-sidebar';
import { RequiredSwitch } from '../required-switch';

type Config = FieldConfig<'input-phone'>;

const Display: Config['Display'] = ({ field }) => {
  return (
    <PhoneField
      label={asteriskLabel(field.label, field.isRequired)}
      labelIcon={field.companyAttributeId ? <IconAttributeTraveller size={16} /> : undefined}
    />
  );
};

const FormBuilderPhone: Config['Component'] = ({ field, dragHandle }) => {
  const actions = useFormBuilderContext().store.actions;

  return (
    <FieldDropzone field={field}>
      <FieldEdit
        field={field}
        dragHandle={dragHandle}
        display={<Display field={field} />}
        edit={
          <>
            <TextField
              onChange={actions.createChangeHandler(field, 'label')}
              defaultValue={field.label}
              label={t('label')}
              maxChars={255}
            />
            <RequiredSwitch field={field} />
          </>
        }
      />
    </FieldDropzone>
  );
};

const { t } = getScopedTranslate({
  en: {
    title: 'Phone number',
    label: 'Label',
  },
});

export const phoneConfig: Config = {
  kind: 'input-phone',
  title: t('title'),
  group: 'inputs',
  propertiesTabs: [conditionsTab],
  Display,
  TreeDisplay: ({ field }) => <FieldSidebarLabel label={field.label} />,
  Icon: IconPhone,
  Component: FormBuilderPhone,
};
